import React, { useState, useEffect, useRef } from 'react';
import ComplianceComparison from '../Shared/ComplianceComparison.js';

const RegulatoryReviewsDocumentComparison = ({ entityType, originalUniqueId, originalMediaPath, originalTitle, originalTranslationMediaPath,
	comparisonUniqueId, comparisonMediaPath, comparisonTranslationMediaPath, comparisonTitle, closePopup = null }) => {


	let AppContext = { entityType: entityType, currentItem: { MediaPath: null, MedboardResourceId: null } };
	let screenType = "comparison";
	let setScreenType = () => { };
	let selectedPDFVersion = { UniqueId: originalUniqueId, MediaPath: originalMediaPath, Title: originalTitle, TranslationMediaPath: originalTranslationMediaPath };
	let selectedPDFVersionComparison = { UniqueId: comparisonUniqueId, MediaPath: comparisonMediaPath, Title: comparisonTitle, TranslationMediaPath: comparisonTranslationMediaPath };


	if (!closePopup) {

		closePopup = () => {
			let redlineContainerElement = document.getElementById("redline-comparator-container");

			if (redlineContainerElement)
				redlineContainerElement.style.display = "none";
		}
	}




	//HERE

	return <ComplianceComparison
		AppContext={AppContext}
		screenType={screenType}
		setScreenType={setScreenType}
		selectedPDFVersion={selectedPDFVersion}
		selectedPDFVersionComparison={selectedPDFVersionComparison}
		closePopup={closePopup}
	/>
}


export default RegulatoryReviewsDocumentComparison;